<template>
  <div class="guestList">
    <div class="row">
      <div class="col-md-12 mb-2">
        <router-link class="return" :to="{
                name: 'Event List'
              }">
          <i class="fas fa-chevron-left"></i>
          {{$t('events.newEvent.back')}}
        </router-link>
      </div>
      <div class="col-md-12 happening" v-if="this.$route.params.isHappeningEvent">
        <span>{{ $t("events.happeningNowAlert") }}</span>
      </div>
      <div class="col-md 4">
        <h4 class="black">{{this.$route.params.name}}</h4>
        <h1 class="black">{{$t('events.listEvents.title')}}</h1>
      </div>
      <div class="col-md-8">
        <div class="texts-header d-flex mt-5">
          <h6 class="black mr-5">
            {{ $t("events.guest.capacity") }} {{this.$route.params.quantity}} {{ $t("events.guest.guests") }}
            <i
              class="far fa-edit edit-icon"
              v-if="!this.$route.params.isHistory"
              @click="openModal"
            ></i>
          </h6>
          <h6 class="black mr-5">
            {{ $t("events.guest.placesAvailables") }}
            <span
              :class="availablePlacesQuantity <=0 ? 'warning-text' : ''"
            >{{availablePlacesQuantity}}</span>
          </h6>

          <h6
            class="black"
          >{{ $t("events.guest.invitation") }} {{this.$route.params.sendInvitationsTotal}}</h6>
        </div>
      </div>
      <div class="switchs">
        <SwitchButtons name="guestList" :values="types" @tipo="setTable" />
        <PendingTable
          v-if="tableToShow ==='pending'"
          class="mt-3 ml-3"
          :isHappening="this.$route.params.isHappeningEvent"
          :quantity="availablePlacesQuantity"
        ></PendingTable>
        <ConfirmedTable
          v-if="tableToShow ==='confirmed'"
          class="mt-3 ml-3"
          :isHappening="this.$route.params.isHappeningEvent"
          :quantity="availablePlacesQuantity"
        ></ConfirmedTable>
        <CancelledTable
          v-if="tableToShow ==='cancelled'"
          class="mt-3 ml-3"
          :isHappening="this.$route.params.isHappeningEvent"
        ></CancelledTable>
        <WaitingTable
          :quantity="availablePlacesQuantity"
          v-if="tableToShow ==='waiting'"
          class="mt-3 ml-3"
        ></WaitingTable>
        <ExternalTable
          v-if="tableToShow ==='external'"
          class="mt-3 ml-3"
          :isHappening="this.$route.params.isHappeningEvent"
          :quantity="availablePlacesQuantity"
        ></ExternalTable>
        <InsideTable
          v-if="tableToShow ==='inside'"
          class="mt-3 ml-3"
          :isHappening="this.$route.params.isHappeningEvent"
        ></InsideTable>
      </div>
    </div>
    <Modal v-if="modalActive" @closeModal="closeModal">
      <template #header>
        <h6 class="modal-title bolded">{{ $t("events.guest.addMoreCapacity") }}</h6>
      </template>
      <template>
        <input
          :class="quantity%(+numberCompanionsAllowed+1)!==0 || quantity < originalAvailablePlaces ?  'warning-input' : ''"
          type="number"
          class="quantity"
          v-model.number="quantity"
        />
        <p
          class="alert-text"
          v-if="quantity%(+numberCompanionsAllowed+1)!==0"
        >{{ $t("events.newEvent.multiplesAlert") }} {{(+numberCompanionsAllowed + 1) }}</p>
        <p
          class="alert-text"
          v-if="quantity < originalAvailablePlaces"
        >{{ $t("events.newEvent.minorValue") }} {{originalAvailablePlaces}}</p>
      </template>
      <template #footer>
        <div class="controls">
          <span class="control cancel-btn mr-4" @click="closeModal">
            {{
            $t("map.benefits.list.modal.cancel")
            }}
          </span>
          <span
            type="control button"
            class="control entered-btn"
            :class="quantity%(+numberCompanionsAllowed+1)!==0 || quantity < originalAvailablePlaces?  'disable-upload' : ''"
            @click="changeAvailablePlaces"
          >{{ $t("events.guest.modify") }}</span>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import API_SERVICE from "@/lib/api/Events.js";
const SwitchButtons = () => import("@/components/Switch");
const PendingTable = () => import("../events/tables/PendingTable.vue");
const ConfirmedTable = () => import("../events/tables/ConfirmedTable.vue");
const CancelledTable = () => import("../events/tables/CancelledTable.vue");
const WaitingTable = () => import("../events/tables/WaitingTable.vue");
const ExternalTable = () => import("../events/tables/ExternalTable.vue");
const InsideTable = () => import("../events/tables/InsideTable.vue");
const Modal = () => import("@/components/Modal");
const api = new API_SERVICE();

export default {
  components: {
    SwitchButtons,
    PendingTable,
    ConfirmedTable,
    CancelledTable,
    WaitingTable,
    ExternalTable,
    InsideTable,
    Modal,
  },
  props: ["hola"],
  data() {
    return {
      tableToShow: "pending",
      modalActive: false,
      quantity: 0,
      numberCompanionsAllowed: 0,
      originalAvailablePlaces: 0,
      originalBusyPlaces: 0,
      availablePlacesQuantity: 0,
      busyPlaces: 0,
    };
  },
  beforeMount() {
    this.quantity = this.$route.params.quantity;

    this.originalBusyPlaces = this.$route.params.busyPlaces;
    this.availablePlacesQuantity =
      this.quantity - +this.$route.params.busyPlaces;
  },
  methods: {
    setTable: function (types) {
      this.tableToShow = types;
      let busy = this.$store.getters["global/respGuest"];
      if (this.originalBusyPlaces !== busy) {
        this.originalBusyPlaces = busy;
        this.availablePlacesQuantity = this.originalAvailablePlaces - busy;
      }
    },

    openModal: function () {
      this.modalActive = true;
    },
    closeModal: function () {
      this.modalActive = false;
    },
    async changeAvailablePlaces() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        const resp = await api.editEvent(
          { availablePlaces: this.quantity },
          this.$route.params.id
        );
        this.$route.params.quantity = this.quantity;
        let busy = this.$store.getters["global/respGuest"];
        this.availablePlacesQuantity = this.quantity - busy;
        this.originalAvailablePlaces = this.quantity;
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
        this.closeModal();
      }
    },
  },
  mounted() {
    if (this.$route.params.quantity) {
      this.quantity = this.$route.params.quantity;
      this.numberCompanionsAllowed = this.$route.params.numberCompanionsAllowed;
      this.originalAvailablePlaces = this.$route.params.quantity;
    }
  },
  computed: {
    types: function () {
      return [
        {
          label: this.$t("events.listEvents.tabs.responsePending"),
          value: "pending",
        },
        {
          label: this.$t("events.listEvents.tabs.confirmation"),
          value: "confirmed",
        },
        {
          label: this.$t("events.listEvents.tabs.cancel"),
          value: "cancelled",
        },
        {
          label: this.$t("events.listEvents.tabs.waitingList"),
          value: "waiting",
        },
        {
          label: this.$t("events.listEvents.tabs.externalGuest.title"),
          value: "external",
        },
        {
          label: this.$t("events.listEvents.tabs.enterEvent.title"),
          value: "inside",
        },
      ];
    },
  },
};
</script>

<style>
.black {
  color: #000 !important;
}
.switchs {
  width: 100%;
}
.happening {
  background: #bb0a30;
  color: #fff;
  text-align: center;
  border-radius: 0px;
  font-weight: bold;
  padding: 1rem;
  margin-top: 0.5rem;
}
.guestList .modal-container {
  max-width: 20vw !important;
}
.guestList .controls {
  display: flex;
  justify-content: end;
  align-items: flex-end;
}
.guestList .controls .cancel-btn,
.guestList .controls .entered-btn {
  cursor: pointer;
}
.guestList .controls .entered-btn {
  background: #000 !important;
  color: #fff !important;
  padding: 0.5rem;
}
.guestList .controls .cancel-btn {
  padding: 0.5rem;
}
.edit-icon {
  cursor: pointer;
}
.bolded {
  font-weight: bold !important;
  color: #000;
}
.warning-text {
  color: #bb0a30 !important;
}
.disable-upload {
  pointer-events: none !important;

  opacity: 0.3 !important;
}
.alert-text {
  color: #bb0a30;
  margin-top: 0.5rem;
}
</style>